// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e0edf282","455":"9979563b","977":"07b98ebe"}[chunkId] + ".chunk.js";
};